import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'recompose';

import { Button, Icon } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './ModalSignOutDuringConsultation.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  testId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const headerMessage = { id: 'SessionTermination.Error.SignoutDuringConsultationDialog.Title', defaultMessage: '** You cannot sign out during a consultation' };
const bodyMessage = {
  id: 'SessionTermination.Error.SignoutDuringConsultation.Dialog.Body',
  defaultMessage: '** You are in an active consultation. Please end the consultation to sign out.',
};

const ModalSignOutDuringConsultation = ({ intl, onCancel }) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <FormattedMessage { ...headerMessage } />
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.body }>
      <FormattedMessage { ...bodyMessage } />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-sign-out-cancel-button"
        buttonType="naked"
        label={ intl.formatMessage({ id: 'General.Close', defaultMessage: '** Close' }) }
        className={ theme.cancelButton }
        labelColor="blackMedium"
        onClick={ onCancel }
      />
    </div>
  </div>
);

ModalSignOutDuringConsultation.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(ModalSignOutDuringConsultation);
